var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHistory = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#034CD7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,74.8c-0.7-0.8-0.5-2.1,0.4-2.7l0,0c0.8-0.6,2-0.4,2.6,0.4C25.5,83,37.8,89.2,50.9,89.2 c22.7,0,41.2-18.4,41.2-41.2S73.6,6.8,50.9,6.8c-18.7,0-35.2,12.9-39.8,30.8c-0.3,0.9-1.3,1.5-2.3,1.3l0,0c-1-0.2-1.7-1.4-1.4-2.4 C12.6,17,30.5,3,50.9,3c24.8,0,45,20.2,45,45s-20.2,45-45,45C36.5,93,23.1,86.2,14.7,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,42.7L9,42.9c-0.9,0.5-1.9,0.3-2.4-0.6L0.3,31.8c-0.5-0.9-0.3-1.9,0.6-2.4l0.2-0.2C2,28.7,3,28.9,3.5,29.8 l6.3,10.5C10.2,41.2,9.9,42.3,9.2,42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,42.3l-0.2-0.2c-0.5-0.9-0.3-1.9,0.6-2.4l10.5-6.3c0.9-0.5,1.9-0.3,2.4,0.6l0.2,0.2 c0.5,0.9,0.3,1.9-0.6,2.4L8.9,42.9C8.1,43.4,7,43.2,6.5,42.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,23.1L50.5,23.1c1.1,0,2.1,0.9,2.1,2.1l0,23.6c0,1.1-0.9,2.1-2.1,2.1l0,0c-1.1,0-2.1-0.9-2.1-2.1V25.2 C48.4,24,49.4,23.1,50.5,23.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,67L68.7,67c-0.8,0.8-2.1,0.8-2.9,0L49,50.3c-0.8-0.8-0.8-2.1,0-2.9l0,0c0.8-0.8,2.1-0.8,2.9,0l16.7,16.7 C69.5,64.9,69.5,66.2,68.7,67z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHistory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/History.cd5dc597.svg";
export { ForwardRef as ReactComponent };